import React, {Component, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import Typical from 'react-typical';
import axios from 'axios';

class Spinners extends Component {
  render() {
    return (
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    );
  }
}

export default function CovidComponent() {
  const [covids, setCovids] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const options = {
    method: 'GET',
    url: 'https://covid-19-tracking.p.rapidapi.com/v1/Indonesia',
    headers: {
      'x-rapidapi-key': '2a83e41c31msh0b689309d2de4a6p1e5b7cjsn5a82ea23d8f6',
      'x-rapidapi-host': 'covid-19-tracking.p.rapidapi.com'
    }
  };

  useEffect(() => {
    setIsLoading(true);

    const getCovid = async () => {
      try {
        let response = await axios.request(options);
        setCovids(response.data);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    getCovid();
  }, []);

  return (
    <div>
      <React.Fragment>
        <div className="container" data-aos="fade-down" data-aos-duration="1000">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <img src="https://blush.design/api/download?shareUri=WoJm3LUSu&c=Skin_0%7E757eff-0.2%7E09b9c6&w=800&h=800&fm=png" className="img-fluid" alt="info" />
            </div>
          </div>
        </div>
        <div className="container my-5" data-aos="fade-up" data-aos-duration="1000">
          <div className="jumbotron text-center text-white">
            <h1 className="display-5">
              <span className="text-light-green fw-bold">COVID-19</span> Indonesia
            </h1>
            <p className="lead">
              <Typical className="text-white fs-1" steps={['Data updated every day', 2000, 'Stay Safe Everyone!', 2000]} loop={Infinity} wrapper="b" />
            </p>
            <hr className="my-4" />
            <div className="row justify-content-center">
              <div className="col-lg-4 mt-4">
                <div className="card bg-glass">
                  <div className="card-header">
                    <h4 className="text-white">Cases</h4>
                  </div>
                  <div className="card-body">{isLoading ? <Spinners /> : <p> {covids['Total Cases_text']} Orang </p>}</div>
                </div>
              </div>
              <div className="col-lg-4 mt-4">
                <div className="card bg-glass">
                  <div className="card-header">
                    <h4 className="text-white">Recovered</h4>
                  </div>
                  <div className="card-body">{isLoading ? <Spinners /> : <p> {covids['Total Recovered_text']} Orang </p>}</div>
                </div>
              </div>
              <div className="col-lg-4 mt-4">
                <div className="card bg-glass">
                  <div className="card-header">
                    <h4 className="text-white">Deaths</h4>
                  </div>
                  <div className="card-body">{isLoading ? <Spinners /> : <p> {covids['Total Deaths_text']} Orang </p>}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    </div>
  );
}
